import React from 'react';
type Tone = 'light' | 'dark';
export function Eyebrow({
  children,
  tone = 'light',
  align = 'center'
}: {
  children: React.ReactNode;
  tone?: Tone;
  align?: 'center' | 'left';
}) {
  return <p className={`mb-2 text-[11px] font-extrabold uppercase tracking-[.18em] md:text-xs ${align === 'center' ? 'text-center' : 'text-left'} ${tone === 'dark' ? 'text-accent-light' : 'text-accent-dark'}`} data-id="element-249" data-mp="2vxarwwrr3qtv">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <h2 className={`mx-auto max-w-4xl text-center text-2xl font-black uppercase leading-tight md:text-4xl ${tone === 'dark' ? 'text-white' : 'text-brand-deep'}`} data-id="element-250" data-mp="30y8a39crgkvd">
      {children}
    </h2>;
}
export function SectionLead({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <p className={`mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed md:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-slate-600'}`} data-id="element-251" data-mp="1ggaexyrpo4kc">
      {children}
    </p>;
}
export function Mark({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="bg-accent-light box-decoration-clone px-1.5 text-brand-deep" data-id="element-252" data-mp="29i9znyt9nkvb">{children}</span>;
}